export default __webpack_public_path__ + "static/media/oshun.e6e8e36b.webp";